import { fetchJSON } from "./utils";

export async function sendFeatureActivationRequest(feature, data) {
  const url = `/api/feature_activation_request/${feature}`;
  return fetchJSON(url, null, data, "post");
}